<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20" id="product-detail">
      <loading v-if="working" class="mt10 text-center" :text="'Please wait'|translate"></loading>
      <div v-if="product">
        <div class="row mt20">
          <div class="col-md-8">
            <div class="media">
              <div class="media-left">
                <a href="#">
                  <img class="media-object" :src="product.feature_image_path" />
                </a>
              </div>
              <div class="media-body">
                <h2>{{ product.name }}</h2>
                <div class="detail mb10" v-html="product.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
export default {
  name: "SearchCode",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      working: false,
      product: null
    };
  },
  methods: {},
  mounted() {
    this.productId = this.$route.params.productId;
    this.productName = this.$route.params.productName;

    let data = {
      id: this.productId
    };
    this.working = true;
    Utils.request(this, true)
      .get(`/productDetail/${this.productId}`)
      .then(response => {
        this.working = false;
        this.product = response.data.data;
        console.log("this.product", this.product);
      })
      .catch(error => {});
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ProductDetail.vue